var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.31029 4.44702H12.9043L13.1973 9.02902L13.4573 13.084C13.4727 13.4326 13.4164 13.7807 13.2921 14.1067C13.1677 14.4328 12.9778 14.7298 12.7342 14.9797C12.4906 15.2295 12.1983 15.4267 11.8755 15.5592C11.5527 15.6917 11.2062 15.7566 10.8573 15.75H3.36029C3.01141 15.7566 2.66487 15.6917 2.34205 15.5592C2.01924 15.4267 1.727 15.2295 1.48337 14.9797C1.23974 14.7298 1.04989 14.4328 0.925522 14.1067C0.801159 13.7807 0.744925 13.4326 0.76029 13.084L1.31029 4.44702Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.818615 12.4221H13.4026L13.4126 12.5701C13.4612 12.9514 13.4316 13.3386 13.3256 13.708C13.2196 14.0775 13.0395 14.4215 12.7962 14.719C12.5529 15.0166 12.2516 15.2615 11.9105 15.4387C11.5695 15.616 11.1959 15.722 10.8126 15.7501H3.40761C3.02376 15.7218 2.64972 15.6154 2.30835 15.4376C1.96698 15.2598 1.66546 15.0143 1.4222 14.716C1.17895 14.4177 0.999076 14.0729 0.893577 13.7028C0.788077 13.3326 0.759168 12.9448 0.808615 12.5631L0.818615 12.4221Z",
    fill: "black",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25977 5.557V4.45C4.25977 2.405 5.53377 0.75 7.10577 0.75C8.67777 0.75 9.95277 2.405 9.95277 4.45V5.557",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommerce);
export default __webpack_public_path__ + "static/media/ecommerce.70958bdfcb35421bd402af12aa967e4a.svg";
export { ForwardRef as ReactComponent };